// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1HFG7","col":"CardReaderDesc_col__1z9Qp","label":"CardReaderDesc_label__2GjTp"};